import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://dr-i66t.onrender.com';
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = 'randevu_admin_token';

export const authStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = authStore.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname.startsWith('/panel-abbasov')) {
      authStore.clear();
      if (!window.location.pathname.endsWith('/login')) {
        window.location.href = '/panel-abbasov';
      }
    }
    return Promise.reject(err);
  }
);

export default api;

// Public + admin helpers
export const publicApi = {
  list: (entity) => api.get(`/public/${entity}`).then((r) => r.data),
  submitContact: (data) => api.post('/public/contact', data).then((r) => r.data),
};

export const adminApi = {
  login: (username, password) => api.post('/admin/login', { username, password }).then((r) => r.data),
  me: () => api.get('/admin/me').then((r) => r.data),
  list: (entity) => api.get(`/admin/${entity}`).then((r) => r.data),
  create: (entity, data) => api.post(`/admin/${entity}`, data).then((r) => r.data),
  update: (entity, id, data) => api.put(`/admin/${entity}/${id}`, data).then((r) => r.data),
  remove: (entity, id) => api.delete(`/admin/${entity}/${id}`).then((r) => r.data),
  upload: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
};

export const buildImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${BACKEND_URL}${path}`;
};
